<!--
 * @Descripttion:
 * @version:
 * @Author: congsir
 * @Date: 2023-03-16 18:00:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-07 10:21:06
-->
<template>
    <div class="h-full w-full overflow-y-auto" id="mainContent" ref="mainContent">

        <!-- <div class="text-sm mt-10 text-center space-y-4">
            <div class="set-box items-center" v-show="conversation.length<2">
                <div v-if="remainDay>0">您当天的剩余次数为{{ remainDay }}</div>
            <div>
                <button
                    class="inline-flex items-center justify-center rounded-full px-4 py-3 text-sm shadow-md bg-blue-600 text-white hover:bg-blue-500 transition-all active:bg-blue-600 group font-semibold disabled:bg-gray-400 space-x-2"><svg
                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="w-5 h-5"
                        height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z">
                        </path>
                    </svg><span>输入 API Key</span>
                </button>
            </div>
            <div class="mt-4"><div class="cursor-pointer text-blue-500 text-xs hover:opacity-80">→ 点击获取专属的API key.</div></div>
            </div>
        </div> -->

        <div class="flex flex-col items-center text-sm dark:bg-gray-800" v-if="conversation">
            <template v-for="(item, index) in conversation" :key="index">
                <div v-if="item.role != 'system'"
                    class="chatitem w-full border-b border-black/10 dark:border-gray-900/50 text-gray-800 dark:text-gray-100 group dark:bg-gray-800">
                    <div class="text-base m-auto md:max-w-2xl lg:max-w-2xl xl:max-w-3xl p-4 md:py-6 flex lg:px-0">
                        <div class="w-[30px] mr-[20px] flex flex-col relative items-end flex-shrink-0">
                            <template v-if="item.role == 'user'">

                                <img src="../assets/image/defaultavator_m.png" alt="header-icon">
                            </template>

                            <template v-if="item.role == 'assistant'">
                                <svg t="1774004313775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9930" width="30" height="30"><path d="M788.014545 46.545455H235.985455C131.351273 46.545455 46.545455 132.049455 46.545455 237.521455v548.95709C46.545455 891.950545 131.351273 977.454545 235.985455 977.454545h552.02909c104.634182 0 189.44-85.504 189.44-190.976V237.521455C977.454545 132.049455 892.648727 46.545455 788.014545 46.545455z" fill="#10A37F" p-id="9931"></path><path d="M734.906182 464.756364a129.768727 129.768727 0 0 0-11.170909-106.542546 131.258182 131.258182 0 0 0-141.312-62.976 129.768727 129.768727 0 0 0-97.047273-43.613091h-1.117091A131.258182 131.258182 0 0 0 359.330909 342.481455 129.768727 129.768727 0 0 0 272.663273 405.410909a131.304727 131.304727 0 0 0 16.104727 153.879273 129.768727 129.768727 0 0 0 11.170909 106.589091 131.258182 131.258182 0 0 0 141.312 62.929454 129.768727 129.768727 0 0 0 97.047273 43.613091H539.461818a131.258182 131.258182 0 0 0 124.881455-90.903273 129.722182 129.722182 0 0 0 86.714182-62.929454 131.072 131.072 0 0 0-16.151273-153.786182z m-195.770182 273.640727h-0.139636c-22.807273 0-44.823273-8.005818-62.370909-22.621091l3.118545-1.722182 103.703273-59.904a16.849455 16.849455 0 0 0 8.517818-14.661818v-146.292364l43.845818 25.320728a1.536 1.536 0 0 1 0.837818 1.210181v121.018182a97.745455 97.745455 0 0 1-97.512727 97.652364z m-209.687273-89.6a97.373091 97.373091 0 0 1-11.636363-65.396364l3.072 1.861818 103.703272 59.904a16.896 16.896 0 0 0 17.035637 0l126.603636-73.076363v50.688a1.536 1.536 0 0 1-0.651636 1.256727l-104.820364 60.509091a97.792 97.792 0 0 1-133.306182-35.746909z m-27.275636-226.350546a97.28 97.28 0 0 1 50.781091-42.821818V503.156364a16.849455 16.849455 0 0 0 8.471273 14.661818l126.603636 73.076363-43.799273 25.320728a1.582545 1.582545 0 0 1-1.489454 0.139636l-104.866909-60.602182a97.698909 97.698909 0 0 1-35.700364-133.259636z m360.122182 83.781819l-126.603637-73.076364 43.799273-25.320727a1.536 1.536 0 0 1 1.489455-0.139637l104.820363 60.509091a97.652364 97.652364 0 0 1-15.080727 176.174546v-123.345455-0.186182a16.802909 16.802909 0 0 0-8.424727-14.615272z m43.613091-65.629091a151.319273 151.319273 0 0 0-3.072-1.861818L599.133091 378.88a16.942545 16.942545 0 0 0-17.035636 0L455.493818 451.956364V401.268364c0-0.512 0.232727-0.977455 0.605091-1.256728l104.866909-60.509091a97.605818 97.605818 0 0 1 144.942546 101.096728z m-274.245819 90.205091l-43.845818-25.320728a1.582545 1.582545 0 0 1-0.837818-1.163636V383.162182a97.605818 97.605818 0 0 1 160.069818-74.938182l-3.118545 1.768727L440.32 369.943273a16.849455 16.849455 0 0 0-8.517818 14.615272v0.093091l-0.093091 146.152728z m23.784728-51.339637l56.413091-32.581818 56.366545 32.581818V544.581818l-56.366545 32.535273-56.413091-32.581818v-65.070546z" fill="#FFFFFF" p-id="9932"></path></svg>
                            </template>

                        </div>
                        <div
                            class="prose prose-p:m-0 prose-ul:m-0 prose-ul:leading-normal prose-li:m-0 prose-ol:m-0 prose-pre:w-full prose-pre:p-0 prose-pre:h-fit prose-pre:bg-black prose-pre:text-white w-0 flex-grow">
<!--                            whitespace-pre-wrap-->
                            <div class="answer min-h-[20px] flex flex-col items-start gap-4  text-left">
                                <template v-if="item.type == 'error'">
                                    <div class="error">{{item.content}}</div>
                                </template>
                                <template v-else>
                                    {{ load(item.content) }}
                                    <template v-if="item.content">
<!--                                        <Markdown  class="markdown-wrapper" />-->

                                        <div :class="item.role == 'assistant'  && fetchStatus ? 'active' : ''"
                                              v-html="renderText(item.content)" class="markdown prose w-full break-words dark:prose-invert dark"></div>

                                    </template>
                                    <template v-else>
                                        <div class="animate-blink"></div>
                                    </template>

                                </template>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="w-full h-32 md:h-48 flex-shrink-0"></div>
    </div>
</template>


<script>
import { onMounted, ref } from 'vue';
// import Markdown from 'vue3-markdown-it';
import MarkdownIt from 'markdown-it'
import ClipboardJS from 'clipboard';
import hljs from 'highlight.js'
import mdKatex from '@traptitech/markdown-it-katex'
console.info(MarkdownIt)

export default {
    name: "mainContent",
    // components: { Markdown },
    props: {
        conversation: Array,
        fetchStatus: Boolean,
        remainDay:Number,
    },
    setup(props, { emit }) {

        let mainContent = null;
        let hasScrollBottom = ref(false)
        onMounted(() => {
            console.log("mounted")
            //    mainContent 滚动到底部

            mainContent = document.getElementById("mainContent");


            //    监听mainContent滚动事件
            mainContent.addEventListener("scroll", () => {
                console.log("scroll")
                //    距离底部50px时触发
                if (mainContent.scrollHeight - mainContent.scrollTop - mainContent.clientHeight < 200) {
                    hasScrollBottom.value = true;
                } else {
                    hasScrollBottom.value = false;
                }
            })

        })

        function highlightBlock(str, lang) {
            return `<pre class="code-block-wrapper"><div class="code-block-header flex items-center relative text-gray-200 bg-gray-600 px-4 py-2 text-xs font-sans justify-between rounded-t-md"><span class="code-block-header__lang">${lang}</span><span class="code-block-header__copy cursor-pointer copy-code">copyCode</span></div><code class="hljs  code-block-body ${lang}">${str}</code></pre>`
        }



        const clipboard = new ClipboardJS('.copy-code', {
            text: function (trigger) {
                return trigger.parentElement.nextElementSibling.textContent;
            }
        });

        clipboard.on('success', function (e) {
            e.clearSelection();

            if(e.trigger.innerText == 'copyCode') {
                e.trigger.innerText = 'copied'
                setTimeout(() => {
                    e.trigger.innerText = 'copyCode'
                }, 2000)
            }

            // 复制成功的处理逻辑，例如显示提示信息
        });

        clipboard.on('error', function (e) {

            // 复制失败的处理逻辑，例如显示提示信息
        });


        const mdi = new MarkdownIt({
            linkify: true,
            highlight(code, language) {
                const validLang = !!(language && hljs.getLanguage(language))
                if (validLang) {
                    const lang = language ?? ''
                    return highlightBlock(hljs.highlight(lang, code, true).value, lang)
                }
                return highlightBlock(hljs.highlightAuto(code).value, '')
            },
        })
        mdi.use(mdKatex, { blockClass: 'katexmath-block rounded-md p-[10px]', errorColor: ' #cc0000' })


        const renderText = (text) => {
            return mdi.render(text)
        }

        const load = () => {
            if (hasScrollBottom.value) {
                mainContent.scrollTop = mainContent.scrollHeight
            }

        }

        return {
            load,renderText
        }



    }


}
</script>


<style lang="scss">

@import "../assets/github-markdown.scss";

.markdown{
    line-height: 30px;
}

.animate-blink {
    height: 20px;
    width: 5px;
    content: "";
    display: inline-block;
    animation: blink 1s infinite;
    background: #666;
    margin-left: 6px;
    // 上面居中
    vertical-align: bottom;
}

.error {
    color: red;
}

.chatitem:last-child .markdown-wrapper.active>*:last-child:after {
    height: 20px;
    width: 5px;
    content: "";
    display: inline-block;
    animation: blink 1s infinite;
    background: #666;
    margin-left: 6px;
    // 上面居中
    vertical-align: bottom;
}

.prose :where(ol>li):not(:where([class~=not-prose] *))::marker {
    font-weight: 400;
}


@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}</style>

